export const API_URL = 'https://app.malakaltawouk.com/api/website'
